import { render, staticRenderFns } from "./NewKanbam.vue?vue&type=template&id=f492f086&scoped=true&"
import script from "./NewKanbam.vue?vue&type=script&lang=ts&"
export * from "./NewKanbam.vue?vue&type=script&lang=ts&"
import style0 from "./NewKanbam.vue?vue&type=style&index=0&id=f492f086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f492f086",
  null
  
)

export default component.exports